export default __webpack_public_path__ + "static/assets/med_x_pipette_mask.b14baf4c.png";